import { NgModule } from "@angular/core";
import { RouteBreadcrumbComponent } from "./route-breadcrumb.component";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@NgModule({
  declarations: [RouteBreadcrumbComponent],
  exports: [RouteBreadcrumbComponent],
  imports: [RouterLink, TranslatePipe],
})
export class BreadcrumbComponentModule {}
